import { render } from "./ImportationPlace.vue?vue&type=template&id=1381e694&ts=true"
import script from "./ImportationPlace.vue?vue&type=script&lang=ts"
export * from "./ImportationPlace.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__